'use strict';

module.exports = require('./offline-web');


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-beacon/extensions/offline-web/index.js
// module id = 682
// module chunks = 0 1